<template>
  <v-card class="mb-3">
    <v-card-title class="title"
      >Key Mapper - Staff
      <v-spacer></v-spacer>
    </v-card-title>
    <v-layout
      class="d-flex pa-3"
      style="justify-content: space-between; flex-wrap: wrap;"
    >
      <v-flex sm6 md3 lg2 v-for="key in mappingKeys" :key="key">
        <v-select
          v-model="keyMap[key]"
          :items="remainList"
          :label="key.toUpperCase()"
          required
        ></v-select>
      </v-flex>
    </v-layout>
    <v-flex style="text-align: right" class="pa-3">
      <v-btn
        class="elevation-0"
        color="primary"
        @click="$emit('process', keyMap, requiredKeys, 'staff')"
      >
        Process
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  props: {
    bulk: Object
  },
  data() {
    return {
      keyMap: {
        staff_id: "",
        first_name: "",
        last_name: "",
        mobile: "",
        email: "",
        status: 1,
        enable_print_label: false
      },
      requiredKeys: ["mobile"],
      validHeaders: []
    };
  },
  computed: {
    mappingKeys: function() {
      return Object.keys(this.keyMap).filter(obj => {
        return !["status", "enable_print_label"].includes(obj);
      });
    },
    remainList: function() {
      return this.bulk.headers;
    }
  }
};
</script>
